<div *ngIf="wordpressData" class="flex flex-wrap gap-2">
  <div *ngFor="let item of convertToArray(wordpressData)">
    <app-wordpress-check checked="{{item.checked}}" label="{{item.label}}"></app-wordpress-check>
  </div>
</div>
